import React from 'react';
import PropTypes from 'prop-types';

const CodeBlock = ({ id, codeSnippet }) => {
  const divStyle = {
    width: '100%',
    background: '#EEE',
    borderRadius: '0.5rem',
    padding: '0.75rem',
    maxHeight: '10rem',
    overflowY: 'scroll',
    marginBottom: '1rem',
    fontSize: '0.8rem',
  };

  const preStyle = {
    margin: 0,
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
  };

  return (
    <div id={id} style={divStyle}>
      <pre style={preStyle}>{JSON.stringify(codeSnippet, null, 2)}</pre>
    </div>
  );
};

CodeBlock.propTypes = {
  id: PropTypes.string,
  codeSnippet: PropTypes.any.isRequired,
};

export default CodeBlock;
